<div data-cy="drag-and-drop-dropzone-error" class="dropzone">
    <p>{{message}}</p>
</div>
